/**
 * Presentational PDF pane — pass a presigned S3 URL (or any URL pdf.js can fetch).
 * Parent owns loading state while detail is fetched.
 */
import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import PDFViewer from '../../PDFViewer';
import styles from './labelSeparation.styles';

type SignedPdfViewerPaneProps = {
  loading: boolean;
  pdfUrl: string | null;
  emptyMessage?: string;
  height?: string;
};

const SignedPdfViewerPane = ({
  loading,
  pdfUrl,
  emptyMessage = "Can't open this PDF",
  height = '100%'
}: SignedPdfViewerPaneProps) => {
  if (loading) {
    return (
      <Box sx={{ ...styles.pdfLoadingBox, height }}>
        <LinearProgress color='secondary' />
      </Box>
    );
  }

  if (pdfUrl) {
    return (
      <Box sx={{ ...styles.pdfViewerBox, height }}>
        <PDFViewer fileUrl={pdfUrl} defaultScale={1} />
      </Box>
    );
  }

  return (
    <Box sx={{ ...styles.pdfEmptyBox, height }}>
      <Typography sx={styles.pdfEmptyText}>{emptyMessage}</Typography>
    </Box>
  );
};

SignedPdfViewerPane.defaultProps = {
  emptyMessage: "Can't open this PDF",
  height: '100%'
};

export default SignedPdfViewerPane;
